import { reactive } from "vue";

export const requestAssignmentStore = reactive({
  isAssigned: 0,
  isUnassigned: 0,
  legalTeamUpdated: 0,
  statusUpdated: 0,
  notesUpdated: 0,
  unassignRequestData: null,
  closingRequestData: null,
  invalidFiles: [] as string[],
  filesAttached: null,
  requestDocuments: [] as any[],
  assignmentData: null,
  selectedDropdownRole: null,
  practitionerQueuePageNumber: 0,
  isFilterModalOpen: false,
  appliedFilters: null,
  filtersAppliedKey: 0,
  isSearchDrawerOpen: false, // Deprecated: to be removed with Search V1.
  aiSearchQuery: "", // Deprecated: to be removed with Search V1.
  aiSearchLoading: false, // Deprecated: to be removed with Search V1.
  aiSearchResult: null as any, // Deprecated: to be removed with Search V1.
  aiSearchError: null as string | null, // Deprecated: to be removed with Search V1.
  /** Cached assignment-matrix rows for workbench service-catalogue filter (keyed by sorted group membership ids). */
  serviceCatalogueFilterCache: null as null | { membershipKey: string; teamIds: number[]; rows: any[] }
});
